import React from 'react'

const SvgPlayOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.943 2.3c.592-.364 1.242-.397 1.951-.1l12.026 8.013c.72.447 1.08 1.043 1.08 1.79 0 .747-.36 1.343-1.08 1.79L6.894 21.8c-.706.297-1.356.262-1.95-.105-.595-.368-.91-.93-.944-1.685V3.99c.038-.76.352-1.324.943-1.69zM6 4v16l12-8L6 4z'
    />
  </svg>
)

export default SvgPlayOutline
